import styled, { keyframes } from "styled-components";

import { media } from "../styles/media";

// Same shimmer sweep the ticket-details skeleton uses, kept visually identical.
const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

export const ServicesStyles = styled.section`
  min-height: calc(100vh - 42px);

  .card {
    margin-top: ${({ theme }) => theme.spacing[24]};

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .filters {
      display: flex;
      align-items: flex-end;
      gap: ${({ theme }) => theme.spacing[24]};
      padding-bottom: ${({ theme }) => theme.spacing[32]};

      .searchWrapper {
        width: 360px;
        position: relative;

        .searchInner {
          width: 100%;
          height: 42px;
          border-radius: ${({ theme }) => theme.radius[12]};
          border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
          overflow: hidden;
          color: ${({ theme }) => theme.colors.semantic.icon.weak};
          transition: border-color 0.2s ease, color 0.2s ease;

          &:focus-within {
            border-color: ${({ theme }) => theme.colors.semantic.text.strong};
            color: ${({ theme }) => theme.colors.semantic.icon.strong};
          }

          .searchInput {
            border: none;
            border-radius: 0;
          }
        }

        .searchHint {
          position: absolute;
          top: calc(100% + 4px);
          left: 4px;
          margin: 0;
          font-size: 11px;
          line-height: 14px;
          letter-spacing: 0.1px;
          color: ${({ theme }) => theme.colors.semantic.text.weak};
          white-space: nowrap;
          pointer-events: none;
        }
      }

      .dateFilterWrapper {
        position: relative;
        flex-shrink: 0;
      }

      .dateFilterRow {
        display: flex;
        align-items: center;
        min-height: 36px;
        gap: ${({ theme }) => theme.spacing[12]};

        .dateFilterToggleLabel {
          font-size: 12px;
          line-height: 16px;
          font-weight: 500;
          color: ${({ theme }) => theme.colors.semantic.text.strong};
          user-select: none;
        }
      }

      .dateTriggerAnchor {
        position: relative;
      }

      .dateTrigger {
        display: flex;
        align-items: center;
        gap: ${({ theme }) => theme.spacing[12]};
        height: 42px;
        padding: 0 ${({ theme }) => theme.spacing[16]} 0
          ${({ theme }) => theme.spacing[12]};
        border-radius: ${({ theme }) => theme.radius[12]};
        border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
        background: ${({ theme }) => theme.colors.semantic.container.white};
        font-family: ${({ theme }) => theme.typography.fontFamily};
        font-size: 13px;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.semantic.text.strong};
        cursor: pointer;
        outline: none;
        white-space: nowrap;
        transition: border-color 0.2s ease, background 0.2s ease;

        &:hover,
        &.open {
          border-color: ${({ theme }) => theme.colors.semantic.text.strong};
        }

        .dateTriggerText {
          font-variant-numeric: tabular-nums;
        }

        .chevron {
          width: 0;
          height: 0;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-top: 5px solid ${({ theme }) => theme.colors.semantic.text.weak};
          transition: transform 0.2s ease;
        }

        &.open .chevron {
          transform: rotate(180deg);
        }
      }

      .dateDialog {
        position: absolute;
        top: calc(100% + 6px);
        left: 0;
        min-width: 420px;
        padding: ${({ theme }) => theme.spacing[16]};
        border-radius: ${({ theme }) => theme.radius[12]};
        border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
        background: ${({ theme }) => theme.colors.semantic.container.white};
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        z-index: 20;
        display: flex;
        flex-direction: column;
        gap: ${({ theme }) => theme.spacing[12]};

        .dateModeRow {
          display: flex;
          flex-direction: column;
        }

        .datePresetRow {
          display: flex;
          flex-direction: column;
        }

        .customDropdown {
          position: relative;
          margin-top: 2px;
        }

        .customDropdownTrigger {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          padding: ${({ theme }) => theme.spacing[8]};
          border-radius: ${({ theme }) => theme.radius[4]};
          border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
          background: ${({ theme }) => theme.colors.semantic.container.white};
          font-family: ${({ theme }) => theme.typography.fontFamily};
          font-style: normal;
          font-weight: ${({ theme }) => theme.typography.body.b2.weight};
          font-size: ${({ theme }) => theme.typography.body.b2.size};
          line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
          color: ${({ theme }) => theme.colors.semantic.text.strong};
          cursor: pointer;
          outline: none;
          transition: border-color 0.2s ease;

          &:hover,
          &.open {
            border-color: ${({ theme }) => theme.colors.semantic.text.strong};
          }

          .chevron {
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 5px solid ${({ theme }) => theme.colors.semantic.text.weak};
            transition: transform 0.2s ease;
            margin-left: ${({ theme }) => theme.spacing[8]};
          }

          &.open .chevron {
            transform: rotate(180deg);
          }
        }

        .customDropdownMenu {
          position: absolute;
          top: calc(100% + 4px);
          left: 0;
          right: 0;
          z-index: 30;
          padding: ${({ theme }) => theme.spacing[8]};
          border-radius: ${({ theme }) => theme.radius[12]};
          border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
          background: ${({ theme }) => theme.colors.semantic.container.white};
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
          display: flex;
          flex-direction: column;
          gap: 2px;
          max-height: 280px;
          overflow-y: auto;
        }

        .customDropdownItem {
          padding: ${({ theme }) => theme.spacing[8]}
            ${({ theme }) => theme.spacing[12]};
          font-family: ${({ theme }) => theme.typography.fontFamily};
          font-style: normal;
          font-weight: ${({ theme }) => theme.typography.body.b2.weight};
          font-size: 13px;
          line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
          color: ${({ theme }) => theme.colors.semantic.text.weak};
          border-radius: ${({ theme }) => theme.radius[4]};
          cursor: pointer;
          transition: background 0.15s ease, color 0.15s ease;

          &:hover {
            background: ${({ theme }) => theme.colors.accent[50]};
          }

          &.selected {
            color: ${({ theme }) => theme.colors.semantic.text.strong};
            font-weight: 600;
          }
        }

        .datePickersRow {
          display: flex;
          gap: ${({ theme }) => theme.spacing[12]};
        }

        .datePickerCol {
          display: flex;
          flex-direction: column;
        }

        .dateHint {
          margin: ${({ theme }) => theme.spacing[4]} 0 0 0;
          font-size: 11px;
          line-height: 14px;
          letter-spacing: 0.1px;
          color: ${({ theme }) => theme.colors.semantic.text.weak};
        }

        .dateDialogActions {
          display: flex;
          justify-content: flex-end;
          margin-top: ${({ theme }) => theme.spacing[4]};
          padding-top: ${({ theme }) => theme.spacing[12]};
          border-top: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};

          .applyBtn {
            min-width: 120px;
            min-height: 36px;
            justify-content: center;
            padding: ${({ theme }) => theme.spacing[8]}
              ${({ theme }) => theme.spacing[24]};
            font-weight: 600;
          }
        }

        /* The 420px dialog overflows a phone; cap it and stack the two date
           pickers so they don't run off-screen. */
        ${media.maxMobile`
          min-width: 0;
          width: min(86vw, 360px);

          .datePickersRow {
            flex-direction: column;
            gap: 8px;
          }
        `}
      }

      /* Stack the toolbar below the tablet breakpoint. Placed after the base
         child rules so the full-width overrides win by source order. */
      ${media.maxTablet`
        flex-direction: column;
        align-items: stretch;
        gap: 16px;

        .searchWrapper {
          width: 100%;

          /* Nested under .searchWrapper to match the base rule's specificity
             (.searchWrapper .searchHint), otherwise the base position:absolute
             wins and the hint overlaps the date filter. */
          .searchHint {
            position: static;
            margin: 8px 0 12px;
            line-height: 1.4;
            white-space: normal;
          }
        }

        .dateFilterWrapper {
          width: 100%;
        }
      `}
    }
  }

  .statusFilters {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;

    .chips {
      display: flex;
      gap: 6px;
      flex-wrap: wrap;
    }

    .sortFilterWrapper {
      position: relative;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      gap: ${({ theme }) => theme.spacing[8]};
      min-height: 36px;
    }

    .sortFilterLabel {
      font-size: 12px;
      line-height: 16px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.semantic.text.strong};
      user-select: none;
    }

    .sortTrigger {
      display: flex;
      align-items: center;
      gap: ${({ theme }) => theme.spacing[12]};
      height: 36px;
      padding: 0 ${({ theme }) => theme.spacing[16]} 0
        ${({ theme }) => theme.spacing[12]};
      border-radius: ${({ theme }) => theme.radius[12]};
      border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
      background: ${({ theme }) => theme.colors.semantic.container.white};
      font-family: ${({ theme }) => theme.typography.fontFamily};
      font-size: 13px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.semantic.text.strong};
      cursor: pointer;
      outline: none;
      white-space: nowrap;
      transition: border-color 0.2s ease, background 0.2s ease;
      min-width: 180px;

      &:hover,
      &.open {
        border-color: ${({ theme }) => theme.colors.semantic.text.strong};
      }

      .sortTriggerText {
        flex: 1;
        text-align: left;
      }

      .chevron {
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 5px solid ${({ theme }) => theme.colors.semantic.text.weak};
        transition: transform 0.2s ease;
      }

      &.open .chevron {
        transform: rotate(180deg);
      }
    }

    .sortMenu {
      position: absolute;
      top: calc(100% + 4px);
      right: 0;
      min-width: 200px;
      z-index: 30;
      padding: ${({ theme }) => theme.spacing[8]};
      border-radius: ${({ theme }) => theme.radius[12]};
      border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
      background: ${({ theme }) => theme.colors.semantic.container.white};
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    .sortMenuItem {
      padding: ${({ theme }) => theme.spacing[8]}
        ${({ theme }) => theme.spacing[12]};
      font-family: ${({ theme }) => theme.typography.fontFamily};
      font-size: 13px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.semantic.text.weak};
      border-radius: ${({ theme }) => theme.radius[4]};
      cursor: pointer;
      transition: background 0.15s ease, color 0.15s ease;
      white-space: nowrap;

      &:hover {
        background: ${({ theme }) => theme.colors.accent[50]};
      }

      &.selected {
        color: ${({ theme }) => theme.colors.semantic.text.strong};
        font-weight: 600;
      }
    }

    .chip {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 5px 10px 5px 8px;
      border-radius: 999px;
      border: 1px solid ${({ theme }) => theme.colors.primary[100]};
      background: ${({ theme }) => theme.colors.semantic.background.white};
      color: ${({ theme }) => theme.colors.primary[400]};
      font-size: 11px;
      font-weight: 500;
      cursor: pointer;
      font-family: inherit;

      .dot {
        width: 7px;
        height: 7px;
        border-radius: 999px;
        background: ${({ theme }) => theme.colors.primary[200]};
      }

      .count {
        opacity: 0.7;
        font-variant-numeric: tabular-nums;
      }

      &.on {
        border-color: var(--chip-border);
        background: var(--chip-bg);
        color: var(--chip-fg);

        .dot {
          background: var(--chip-color);
        }
      }
    }
  }

  .tableCard {
    margin-top: ${({ theme }) => theme.spacing[24]};
    overflow: hidden;

    /* 9-column dense table scrolls horizontally as a unit below the tablet
       breakpoint instead of crushing the columns. */
    .tableScroll {
      ${media.maxTablet`
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;

        .tableHead,
        .listRow {
          min-width: 980px;
        }
      `}
    }
  }

  .tableHead {
    padding: ${({ theme }) => theme.spacing[12]} ${({ theme }) => theme.spacing[24]};
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme.colors.semantic.container.gray};
    border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.separator};

    .headTitle {
      font-style: normal;
      font-weight: ${({ theme }) => theme.typography.title.t2.weight};
      font-size: ${({ theme }) => theme.typography.body.b3.size};
      line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
      letter-spacing: 0.1px;
      color: ${({ theme }) => theme.colors.semantic.text.weak};
    }
  }

  .ID {
    width: 6%;
    padding-right: ${({ theme }) => theme.spacing[8]};
  }

  .start {
    width: 11%;
  }

  .finish {
    width: 11%;
  }

  .user {
    width: 14%;
    padding-right: ${({ theme }) => theme.spacing[8]};
  }

  .serviceType {
    width: 16%;
    display: flex;
    align-items: center;
    padding-right: ${({ theme }) => theme.spacing[8]};
  }

  .truck {
    width: 13%;
    padding-right: ${({ theme }) => theme.spacing[8]};
  }

  .trailer {
    width: 13%;
    padding-right: ${({ theme }) => theme.spacing[8]};
  }

  .status {
    width: 8%;
    text-align: left;
  }

  .workers {
    width: 8%;
    display: flex;
    align-items: center;
  }

  /* Search / filter loading state — one skeleton row per line, columns share
     the same width classes as the header so everything stays aligned. */
  .skRow {
    display: flex;
    align-items: center;
    padding: 17px ${({ theme }) => theme.spacing[24]};
    border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.separator};

    &:last-child {
      border-bottom: none;
    }

    .sk-line,
    .sk-pill,
    .sk-avatar {
      display: block;
      height: 12px;
      border-radius: 6px;
      background: #eef0f3
        linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.85) 50%,
          rgba(255, 255, 255, 0) 100%
        );
      background-size: 800px 100%;
      animation: ${shimmer} 1.4s linear infinite;
    }

    .sk-pill {
      height: 22px;
      width: 70%;
      border-radius: 999px;
    }

    .sk-avatar {
      width: 28px;
      height: 28px;
      border-radius: 999px;
    }
  }

  .listRow {
    cursor: pointer;
    position: relative;
    transition: background 0.2s ease;
    user-select: none;
  }

  .listRow:hover {
    background: ${({ theme }) => theme.colors.accent[50]};
  }

  .estimationCard {
    height: unset;
  }
`;
